import { render, staticRenderFns } from "./ListIndustrial.vue?vue&type=template&id=7373f7a2&scoped=true&"
import script from "./ListIndustrial.vue?vue&type=script&lang=js&"
export * from "./ListIndustrial.vue?vue&type=script&lang=js&"
import style0 from "./ListIndustrial.vue?vue&type=style&index=0&id=7373f7a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7373f7a2",
  null
  
)

export default component.exports